import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CitizenComponent } from './citizen.component';

const routes: Routes = [{
  path: '',
  component: CitizenComponent,
  data: {
    title: '',
    breadcrumb: 'Home',
    description: 'MahaSarathi'
  },
  children: [
    { path: '', pathMatch: 'full', redirectTo: 'consent-management' },
    { path: 'consent-management', loadChildren: () => import('./consent-management/consent-management.module').then(m => m.ConsentManagementModule) },
    // { path: 'details', loadChildren: () => import('./details/details.module').then(m => m.DetailsModule) },
    { path: 'profile', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) },
    { path: 'support', loadChildren: () => import('./citizen-support/citizen-support.module').then(m => m.CitizenSupportModule) },
    { path: 'my-access', loadChildren: () => import('./my-access/my-access.module').then(m => m.MyAccessModule) },
    { path: 'scheme', loadChildren: () => import('./citizen-scheme/citizen-scheme.module').then(m => m.CitizenSchemeModule) },
    { path: 'demo-scheme', loadChildren: () => import('./demo-scheme/demo-scheme.module').then(m => m.DemoSchemeModule) },
    // { path: 'details', loadChildren: () => import('./details/details.module').then(m => m.DetailsModule) },
    { path: 'detail', loadChildren: () => import('./detail/detail.module').then(m => m.DetailModule) },
    { path: 'rationCardDetail', loadChildren: () => import('./ration-card-detail/ration-card-detail.module').then(m => m.RationCardDetailModule) },
    { path: 'newdetails', loadChildren: () => import('./newdetails/newdetails.module').then(m => m.NewdetailsModule) },
    { path: 'citizendetail', loadChildren: () => import('./citizendetail/citizendetail.module').then(m => m.CitizendetailModule) },
    { path: 'familycreation', loadChildren: () => import('./family-creation/family-creation.module').then(m => m.FamilyCreationModule) },
    { path: 'familyhistory', loadChildren: () => import('./family-creation/family-history/family-history.module').then(m => m.FamilyHistoryModule) },
    { path: 'consentrequest', loadChildren: () => import('./tpsconsentrequest/tpsconsentrequest.module').then(m => m.TpsconsentrequestModule) },
    { path: 'consentrequestform', loadChildren: () => import('./tpsconsentrequestform/tpsconsentrequestform.module').then(m => m.TpsconsentrequestformModule) },
    { path: 'consenthistory', loadChildren: () => import('./consent-history/consent-history.module').then(m => m.ConsentHistoryModule) },
    { path: 'details', loadChildren: () => import('./citizen-attributedetail/citizen-attributedetail.module').then(m => m.CitizenAttributedetailModule) },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CitizenRoutingModule { }
